import { hasNotKana } from '../../common/utils';
import { OptionalPayment } from '../generated/OptionalPayment';

export class DataRecord {
  readonly data_kubun = '2'; // データレコード
  bank_code = '0040'; // 振込先金融機関コード
  bank_name = 'ｲｵﾝ'; // 振込先銀行名（任意）
  branch_no = ''; // 振込先の支店コード
  branch_name = ''; // 振込先の支店名(かな)任意
  readonly tegata_koukansho_no = ''; //手形交換所番号 未使用
  yokin_shumoku = '1'; // 1:普通、2:当座 4:貯蓄 9:その他
  kouza_bango = ''; //口座番号
  uketorinin_name = ''; //受取人名（カナ）
  furikomi_kingaku = 0; // 振り込み金額

  readonly shinki_code = ''; // 未使用
  client_code1 = ''; // 顧客コード１(10)
  client_code2 = ''; // 顧客コード２(10)
  readonly dummy = ''; // ダミー未使用

  get branchName() {
    return this.branch_name.substr(0, 5);
  }
  user_id = '';
  nickname = '';
  full_name = '';
  lesson_count = 0;
  minutes = 50;
  fee = 0;
  is_target = true;

  toCSV() {
    return `${this.data_kubun},${this.bank_code},${this.bank_name},${this.branch_no},${this.branchName},${this.tegata_koukansho_no},${this.yokin_shumoku},${this.kouza_bango},${this.uketorinin_name},${this.furikomi_kingaku},${this.shinki_code},${this.client_code1},${this.client_code2},${this.dummy}`;
  }

  toGmoCSV() {
    return `${this.bank_code},${this.branch_no},${this.yokin_shumoku},${this.kouza_bango},${this.uketorinin_name},${this.furikomi_kingaku},${this.user_id},`;
  }

  validate() {
    if (this.branch_no.length > 3) {
      this.hasError = true;
      this.errorMessage.push(`振込先の支店コードが桁数(3桁)を超えています。「${this.branch_no.length}桁」`);
    }
    if (this.branch_name.length > 15) {
      this.hasError = true;
      this.errorMessage.push(`振込先の支店名が桁数(15桁)を超えています。「${this.branch_name.length}桁」`);
    }
    if (this.kouza_bango.length > 7) {
      this.hasError = true;
      this.errorMessage.push(`口座番号が桁数(7桁)を超えています。「${this.kouza_bango.length}桁」`);
    }
    if (this.uketorinin_name.length > 30) {
      this.hasError = true;
      this.errorMessage.push(`受取人名が桁数(30桁)を超えています。「${this.uketorinin_name.length}桁」`);
    }
    if (hasNotKana(this.uketorinin_name)) {
      this.hasError = true;
      this.errorMessage.push(`受取人名に半角カタカナ以外の文字が入っています。「${this.uketorinin_name}」`);
    }
    if (this.furikomi_kingaku > 9999999999 || this.furikomi_kingaku < 0) {
      this.hasError = true;
      this.errorMessage.push(`振り込み金額が範囲外です。「${this.uketorinin_name}」`);
    }
  }

  // 予約確認のためのプロパティ
  public reserve_count = 0;
  public commit_count = 0;
  public del_count = 0;
  public reserve_amount = 0;
  public commit_amount = 0;
  public del_amount = 0;

  // オプション金額のためのプロパティ
  public optional_amount = 0;
  public optionalPayments: OptionalPayment[] = [];

  // 行の操作のためのプロパティ
  public hasError = false;
  public errorMessage: string[] = [];
  public selected = true;
}
